import { createContext } from "react";
import { AppContextValue, FeatureFlagProviderName, TextTemplateKey } from "../types";

export const appContextDefaultValue: AppContextValue<TextTemplateKey, object, FeatureFlagProviderName> = {
  appSettings: {
    getLanguage: undefined,
    setLanguage: undefined,
    getTextTemplatesByLanguage: undefined,
    localizedText: undefined,

    getTenant: undefined,
    setTenant: undefined,

    getUser: undefined,
    setUser: undefined,

    getBreakpoints: undefined,
    setBreakpoints: undefined,
    getDesktopBreakpoint: undefined,
    setDesktopBreakpoint: undefined,

    isFeatureFlagEnabled: undefined,

    isPortalDisabled: undefined,

    getCustom: undefined,
    setCustom: undefined,
  },
  appUI: {
    isMobile: undefined,
    isDesktop: undefined,

    getLoading: undefined,
    startLoading: undefined,
    endLoading: undefined,
    resetLoading: undefined,

    openAppDialog: undefined,
    closeAppDialog: undefined,

    showNotification: undefined,
    removeNotification: undefined,

    // todo [BDS-529]
    // refactor useEvalShowHide to not depend on appContext
    // document showIf and hideIf
    // create new showIf* and hideIf* that only use hooks from one ContextProvider
    evalShowHide: undefined,

    showBreadcrumbs: undefined,
    hideBreadcrumbs: undefined,

    showHeader: undefined,
    hideHeader: undefined,
    getHeaderOptions: undefined,
    setHeaderOptions: undefined,
  },
};

/**
 * @deprecated Use the new individual Context Providers.
 */
export const AppContext =
  createContext<AppContextValue<TextTemplateKey, object, FeatureFlagProviderName>>(appContextDefaultValue);
AppContext.displayName = "AppContext";
